import script from "./IncomingCallSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomingCallSnackbar.vue?vue&type=script&setup=true&lang=js"

import "./IncomingCallSnackbar.vue?vue&type=style&index=0&id=ff29ac48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff29ac48"]])

export default __exports__